import React from 'react';
import { Link } from 'react-router-dom';
import './AdminMobileUnavailable.css';

interface AdminMobileUnavailableProps {
  title?: string;
}

const DEFAULT_MESSAGE =
  'Эта страница не поддерживается в мобильной версии. Откройте сайт с компьютера или ноутбука.';

const AdminMobileUnavailable: React.FC<AdminMobileUnavailableProps> = ({
  title = 'Страница недоступна',
}) => (
  <div className="admin-mobile-unavailable">
    <div className="admin-mobile-unavailable-card">
      <div className="admin-mobile-unavailable-icon" aria-hidden>
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <rect x="2" y="3" width="20" height="14" rx="2" />
          <path d="M8 21h8" />
          <path d="M12 17v4" />
        </svg>
      </div>
      <h1 className="admin-mobile-unavailable-title">{title}</h1>
      <p className="admin-mobile-unavailable-text">{DEFAULT_MESSAGE}</p>
      <Link to="/dashboard" className="admin-mobile-unavailable-btn">
        На главную
      </Link>
    </div>
  </div>
);

export default AdminMobileUnavailable;
